module.exports = __webpack_public_path__ + "img/banner.182a2745.jpg";